import React, { useState, useEffect } from 'react';
import tableHelpers from '../helpers/TableHelpers.js'
import RichTable from '../components/richTable/RichTable.jsx'
import { createDateSorter } from '../components/richTable/sorters.js'
import Tooltip from '../components/Tooltip.js'

function AlertTrades(props) {

    const [trades, setTrades] = useState([])

    useEffect(() => {
        (async function () {
            if (props.trades)
                setTrades(props.trades);
        })();
    }, [props.trades]);

    function getTrades() {
        if (trades && trades.length) {
            let id = 0;
            return trades.map(t => {
                return {
                    id: ++id,
                    purchaseDate: t.purchase_date,
                    purchasePrice: t.purchase_price,
                    purchaseData: t.purchase_data,
                    sellDate: t.sell_date,
                    sellPrice: t.sell_price,
                    sellData: t.sell_data,
                    profitPercentage: t.profitPercentage
                }
            })
        } else {
            return [];
        }
    }

    function purchaseDateFormatter(cell, row) {
        return (
            <>
                {tableHelpers.dateFormmatter(cell, row)}

                &nbsp;&nbsp;<Tooltip textClass={"tooltip-link"} text={"🔍"} json={row.purchaseData} width={360} borderWidth={"1px"} position="right center" >
                </Tooltip >
            </>
        )
    }

    function sellDateFormatter(cell, row) {
        return (
            <>
                {tableHelpers.dateFormmatter(cell, row)}

                &nbsp;&nbsp;<Tooltip textClass={"tooltip-link"} text={"🔍"} json={row.sellData} width={360} borderWidth={"1px"} position="right center" >
                </Tooltip >
            </>
        )

    }
    const tradesMapper = [
        { title: 'Id', field: 'id', formatter: tableHelpers.intFormatter },
        { title: 'Purch Date', field: 'purchaseDate', sorters: createDateSorter('purchaseDate'), formatter: purchaseDateFormatter },
        { title: 'Purch Price', field: 'purchasePrice', sorters: true, formatter: tableHelpers.moneyFormatter },
        { title: 'Sell Date', field: 'sellDate', sorters: createDateSorter('sellDate'), formatter: sellDateFormatter },
        { title: 'Sell Price', field: 'sellPrice', sorters: true, formatter: tableHelpers.moneyFormatter },
        { title: 'P/L', field: 'profitPercentage', sorters: true, formatter: tableHelpers.percentFormatter },
    ]

    return (
        <>
            <RichTable pageSize={10} data={getTrades()} mappers={tradesMapper} className="table-striped table-hover table-condensed" />
        </>
    );
}

export default AlertTrades;